import React, { PureComponent } from 'react';
import { object, func, string, instanceOf } from 'prop-types';
import ThanksForFeedbackHeader from './ThanksForFeedbackHeader';
import BrandedHeader from '../../LoginForm/BrandedHeader';
import { Cookies, withCookies } from 'react-cookie';

export const HEADER_TYPES = {
  DEFAULT: 'default header',
  THANKS_FOR_FEEDBACK: 'thanks for feedback header',
};

class AlternatingHeader extends PureComponent {
  static propTypes = {
    runtime: object,
    closeModal: func,
    loginAction: string,
    cookies: instanceOf(Cookies).isRequired,
  };

  static DEFAULT_HEADER = 'default header';

  getHeaderType = () => {
    const { runtime } = this.props;
    return runtime.loginHeaderType || HEADER_TYPES.DEFAULT;
  };

  getHeader() {
    // TODO: more headers and the logic to accompany them
    switch (this.getHeaderType()) {
      case 'thanks for feedback header':
        return ThanksForFeedbackHeader;
      default:
      case AlternatingHeader.DEFAULT_HEADER:
        return BrandedHeader;
    }
  }

  render() {
    const Header = this.getHeader();

    return <Header {...this.props} />;
  }
}

export default withCookies(AlternatingHeader);
